export const actions = {
  ARTICULOS_LOAD_REQUESTED: 'ARTICULOS_LOAD_REQUESTED',
  ARTICULOS_LOAD_SUCCEEDED: 'ARTICULOS_LOAD_SUCCEEDED',
  ARTICULOS_LOAD_FILED: 'ARTICULOS_LOAD_FILED',

  ARTICULOS_FALTANTES_LOAD_REQUESTED: 'ARTICULOS_FALTANTES_LOAD_REQUESTED',
  ARTICULOS_FALTANTES_LOAD_SUCCEEDED: 'ARTICULOS_FALTANTES_LOAD_SUCCEEDED',
  ARTICULOS_FALTANTES_LOAD_FILED: 'ARTICULOS_FALTANTES_LOAD_FILED',

  ARTICULOS_FILTERED_LOAD_REQUESTED: 'ARTICULOS_FILTERED_LOAD_REQUESTED',
  ARTICULOS_FILTERED_LOAD_SUCCEEDED: 'ARTICULOS_FILTERED_LOAD_SUCCEEDED',
  ARTICULOS_FILTERED_LOAD_FILED: 'ARTICULOS_FILTERED_LOAD_FILED',

  ARTICULOS_VENDIDOS_LOAD_REQUESTED: 'ARTICULOS_VENDIDOS_LOAD_REQUESTED',
  ARTICULOS_VENDIDOS_LOAD_SUCCEEDED: 'ARTICULOS_VENDIDOS_LOAD_SUCCEEDED',
  ARTICULOS_VENDIDOS_LOAD_FAILED: 'ARTICULOS_VENDIDOS_LOAD_FAILED',

  ARTICULO_UPDATE_REQUESTED: 'ARTICULO_UPDATE_REQUESTED',
  ARTICULO_UPDATE_SUCCEEDED: 'ARTICULO_UPDATE_SUCCEEDED',
  ARTICULO_UPDATE_FILED: 'ARTICULO_UPDATE_FILED',

  ARTICULO_INSERT_REQUESTED: 'ARTICULO_INSERT_REQUESTED',
  ARTICULO_INSERT_SUCCEEDED: 'ARTICULO_INSERT_SUCCEEDED',
  ARTICULO_INSERT_FILED: 'ARTICULO_INSERT_FILED',

  ARTICULO_DELETE_REQUESTED: 'ARTICULO_DELETE_REQUESTED',
  ARTICULO_DELETE_SUCCEEDED: 'ARTICULO_DELETE_SUCCEEDED',
  ARTICULO_DELETE_FILED: 'ARTICULO_DELETE_FILED',

  ARTICULO_BYID_LOAD_REQUESTED: 'ARTICULO_BYID_LOAD_REQUESTED',
  ARTICULO_BYID_LOAD_SUCCEEDED: 'ARTICULO_BYID_LOAD_SUCCEEDED',
  ARTICULO_BYID_LOAD_FILED: 'ARTICULO_BYID_LOAD_FILED',

  ARTICULO_BYID_LOAD_INSERT_REQUESTED: 'ARTICULO_BYID_LOAD_INSERT_REQUESTED',
  ARTICULO_BYID_LOAD_INSERT_SUCCEEDED: 'ARTICULO_BYID_LOAD_INSERT_SUCCEEDED',
  ARTICULO_BYID_LOAD_INSERT_FILED: 'ARTICULO_BYID_LOAD_INSERT_FILED',

  ARTICULO_PRODUCTO_BYID_LOAD_INSERT_REQUESTED: 'ARTICULO_PRODUCTO_BYID_LOAD_INSERT_REQUESTED',
  ARTICULO_PRODUCTO_BYID_LOAD_INSERT_SUCCEEDED: 'ARTICULO_PRODUCTO_BYID_LOAD_INSERT_SUCCEEDED',
  ARTICULO_PRODUCTO_BYID_LOAD_INSERT_FILED: 'ARTICULO_PRODUCTO_BYID_LOAD_INSERT_FILED',

  ARTICULO_PRODUCTO_DELETE_REQUESTED: 'ARTICULO_PRODUCTO_DELETE_REQUESTED',
  ARTICULO_PRODUCTO_DELETE_SUCCEEDED: 'ARTICULO_PRODUCTO_DELETE_SUCCEEDED',
  ARTICULO_PRODUCTO_DELETE_FILED: 'ARTICULO_PRODUCTO_DELETE_FILED',

  ARTICULOS_PRODUCTOS_INSERT_REQUESTED: 'ARTICULOS_PRODUCTOS_INSERT_REQUESTED',
  ARTICULOS_PRODUCTOS_INSERT_SUCCEEDED: 'ARTICULOS_PRODUCTOS_INSERT_SUCCEEDED',
  ARTICULOS_PRODUCTOS_INSERT_FILED: 'ARTICULOS_PRODUCTOS_INSERT_FILED',

  ARTICULO_STOCK_UPDATE_REQUESTED: 'ARTICULO_STOCK_UPDATE_REQUESTED',
  ARTICULO_STOCK_UPDATE_SUCCEEDED: 'ARTICULO_STOCK_UPDATE_SUCCEEDED',
  ARTICULO_STOCK_UPDATE_FAILED: 'ARTICULO_STOCK_UPDATE_FAILED',
}

export const getArticulosAction = dispatch => {
  dispatch({
    type: actions.ARTICULOS_LOAD_REQUESTED,
  })
}

export const getArticulosFaltantesAction = dispatch => {
  dispatch({
    type: actions.ARTICULOS_FALTANTES_LOAD_REQUESTED,
  })
}

export const getArticulosProductosByIdAction = (dispatch, articuloId) => {
  dispatch({
    type: actions.ARTICULO_PRODUCTO_BYID_LOAD_INSERT_REQUESTED,
    payload: articuloId,
  })
}

export const getArticulosFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.ARTICULOS_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getArticulosVendidosAction = (dispatch, filter) => {
  dispatch({
    type: actions.ARTICULOS_VENDIDOS_LOAD_REQUESTED,
    payload: filter,
  })
}

export const onSubmitInsertArticuloFormAction = (dispatch, formArticulo) => {
  dispatch({
    type: actions.ARTICULO_INSERT_REQUESTED,
    payload: formArticulo,
  })
}

export const onSubmitUpdateArticuloFormAction = (dispatch, formArticulo) => {
  dispatch({
    type: actions.ARTICULO_UPDATE_REQUESTED,
    payload: formArticulo,
  })
}

export const deleteArticuloAction = (dispatch, id) => {
  dispatch({
    type: actions.ARTICULO_DELETE_REQUESTED,
    payload: id,
  })
}

export const getArticuloCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.ARTICULO_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.ARTICULO_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const deleteArticuloProductoAction = (dispatch, id) => {
  dispatch({
    type: actions.ARTICULO_PRODUCTO_DELETE_REQUESTED,
    payload: id,
  })
}

export const onSubmitInserttArticulosProductosFormAction = (dispatch, articulosProductosForm) => {
  dispatch({
    type: actions.ARTICULOS_PRODUCTOS_INSERT_REQUESTED,
    payload: articulosProductosForm,
  })
}

export const onSubmitUpdateArticuloStockFormAction = (dispatch, formArticulo) => {
  dispatch({
    type: actions.ARTICULO_STOCK_UPDATE_REQUESTED,
    payload: formArticulo,
  })
}
